var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.789,
    height: 9.048,
    viewBox: "0 0 7.789 9.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21668",
    "data-name": "Group 21668",
    transform: "translate(-310.746 -2843.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45104",
    "data-name": "Path 45104",
    d: "M315.557,2844h-4.311v8.048h4.311",
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21667",
    "data-name": "Group 21667",
    transform: "translate(314.01 2846.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45105",
    "data-name": "Path 45105",
    d: "M322.38,2857.34h3.7",
    transform: "translate(-322.38 -2855.679)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45106",
    "data-name": "Path 45106",
    d: "M342.562,2851.531l1.661,1.661-1.661,1.66",
    transform: "translate(-340.404 -2851.531)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.ed1e43c56092681225445cd145ea3e7e.svg";
export { ForwardRef as ReactComponent };